import { IS_LOCAL_STORAGE } from '../../constants.js';

const BASE_CONTENT_URL_KEY = 'base.content.url';
const BASE_CONTENT_URL = 'https://static.descope.com/pages';
const BASE_CONTENT_URL_FALLBACK = 'https://static2.descope.com/pages';
const OVERRIDE_CONTENT_URL = (IS_LOCAL_STORAGE && localStorage.getItem(BASE_CONTENT_URL_KEY)) || '';
const ASSETS_FOLDER = 'v2-beta';

export { ASSETS_FOLDER, BASE_CONTENT_URL, BASE_CONTENT_URL_FALLBACK, OVERRIDE_CONTENT_URL };
//# sourceMappingURL=constants.js.map
